module.exports = __webpack_public_path__ + "static/media/ironman-mask-01.6b87631e.png";